/* eslint-disable no-multi-assign */
import qs from 'qs';
import Axios from 'axios';

class CollectReport {
  constructor(options) {
    this.options = {
      reportUrl: options.reportUrl = '/stat/h5/event_analyse/data_upload/',
      reportMethod: options.reportMethod = 'post',
      segmentation: options.segmentation = {},
      noQsStr: options.noQsStr = false,
      // 默认参数 暂时用不到
      /* isFromCYall: false,// 是否在客户端内
            isGreaterAppVersion: 8.3.10,// 客户端版本
            isFromCYWX: false */
    } = options;
  }

  static options() {
    return this.options;
  }

  report() {
    const data = {
      events: JSON.stringify([
        {
          key: this.options.key,
          segmentation: this.options.segmentation,
        },
      ]),
      cyudId: this.options.cyudId || '',
      /* isFromCYall: this.options.isFromCYall,
            isGreaterAppVersion: this.options.isGreaterAppVersion,
            isFromCYWX: this.options.isFromCYWX */
    };
    return Axios({
      url: this.options.reportUrl,
      method: this.options.reportMethod,
      data: this.options.noQsStr ? data : qs.stringify(data),
    });
  }
}
export default CollectReport;
